<template>
  <div>
    <div class="user-entities-cards">
      <template v-for="userEntity in userEntities">
        <candidate-entity-row :userEntity="userEntity"
                              @edit="onUserEntityEdit"
                              @delete="onUserEntityDelete"
                              :withActions="withActions"
                              :key="rowKey(userEntity)" />
      </template>
    </div>

    <div v-if="withActions">
      <template v-for="userEntity in userEntities">
        <candidate-entity-modal :userEntity="userEntity"
                                @validate="onUserEntityValidate"
                                :modalId="modalId(userEntity)"
                                :key="modalKey(userEntity)" />
      </template>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import  CandidateEntityRow from './CandidateEntityRow'
  import  CandidateEntityModal from './CandidateEntityModal'

  export default {
    name: 'CandidateEntitiesTable',
    components: { CandidateEntityRow, CandidateEntityModal },
    props: {
      userEntities: Array,
      withActions: { type: Boolean, default: false }
    },

    methods: {
      ...mapActions({
        initManageableOptions: 'users/initManageableOptions'
      }),
      modalId(userEntity) {
        return `user-entity-${userEntity.entity.id}`;
      },
      modalKey(userEntity) {
        return `modal_${userEntity.entity.id}`
      },
      rowKey(userEntity) {
        return `row_${userEntity.entity.id}`
      },
      headingKey(heading) {
        return `heading_${heading.key}`
      },
      async onUserEntityEdit(userEntity) {
        await this.initManageableOptions( { entityId: userEntity.entity.id });
        $(`#${this.modalId(userEntity)}`).modal('show');
      },
      onUserEntityValidate(userEntity) {
        this.$emit('change', userEntity);
      },
      onUserEntityDelete(userEntity) {
        this.$emit('delete', userEntity);
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/entities/CandidateEntitiesTable.vue